export default {
  ON_BOARDING_GET_PERSON_REPOSITORY: Symbol.for('ON_BOARDING_GET_PERSON_REPOSITORY'),
  GET_ON_BOARDING_PERSON_QUERY: Symbol.for('GET_ON_BOARDING_PERSON_QUERY'),
  ON_BOARDING_UPDATE_PERSON_REPOSITORY: Symbol.for('ON_BOARDING_UPDATE_PERSON_REPOSITORY'),
  UPDATE_ON_BOARDING_PERSON_COMMAND: Symbol.for('UPDATE_ON_BOARDING_PERSON_COMMAND'),
};
